import React from 'react';
import PropTypes from 'prop-types';

const CheckboxGroup = (props) => {

    return (
      <div className={`statuscolor ${props.classes ? props.classes : ""}`}>
        <div className="statuscolor__select">
          {
            props.options.map((opt, key) => 
              <div key={key} className={`col-3 pr-0 statuscolor__item ${props.hasError ? "error" : ""}`}>
                <label className="statuscolor__item-label container pr-0" onClick={props.onChange}>
                  <input
                    type="radio"
                    value={opt.id}
                    checked={props.value == opt.id}
                  />
                  {opt.name}
                </label>
              </div>
            )
          }
        </div>
      </div>
    );
}

CheckboxGroup.propTypes = {
    title: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
}

export default CheckboxGroup;
